import blue from '../colors/blue';
import createThemeColorPalette from '../createThemeColorPalette';

const colorPalette = createThemeColorPalette({
  primary: {
    light: blue[10],
    main: blue[1200],
  },
});

export default colorPalette;
